import axios from '../../common/axios.js'
import LoadingBtn from '../../common/ui/loading_btn.vue'
import CustomInput from '../../common/forms/Input.vue'

export default {
	data(){
		return {
			errors: {},

			durability_side_code: null,
			waste_to_analyze: null,
			analysis_date: null,
			supplier_name: null,
			harvest_year: null,
		}
	},
	props: ['params'],
	created(){
		//Si on a 4 "_" dans le nom de la liste, on pré-rempli les champs avec les valeurs du nom de la liste
		let _name = this.params.parcelle_liste.name.split('_')
		if(_name[0]) this.durability_side_code = _name[0]
		if(_name[1]) this.waste_to_analyze = _name[1]
		if(_name[2]) this.supplier_name = _name[2]
		if(_name[3]) this.harvest_year = _name[3]
	},
	methods:{
		exportRapport(){
			
			this.errors = {}
			if(!this.durability_side_code){
				this.errors.durability_side_code = 'modal_export_rapport_durabilite_durability_side_code_error'
			}
			if(!this.waste_to_analyze){
				this.errors.waste_to_analyze = 'modal_export_rapport_durabilite_waste_to_analyze_error'
			}
			if(!this.analysis_date){
				this.errors.analysis_date = 'modal_export_rapport_durabilite_analysis_date_error'
			}
			if(!this.supplier_name){
				this.errors.supplier_name = 'modal_export_rapport_durabilite_supplier_name_error'
			}
			if(!this.harvest_year){
				this.errors.harvest_year = 'modal_export_rapport_durabilite_harvest_year_error'
			}

			if(!/^\d{4}$/.test(this.harvest_year)){
				this.errors.harvest_year = 'modal_export_rapport_durabilite_harvest_year_error_format'
			}

			if(Object.keys(this.errors).length > 0){
				return
			}else{
				let analysis_date = this.analysis_date.split('-').reverse().join('/')
				axios.post('api=inex/parcelles/export/xls/{view_code}/'+this.params.parcelle_liste.list_id+'/', {
					export_type: "agri",
					user_id: this.$store.state.user.user.email,
					durability_side_code: this.durability_side_code,
					waste_to_analyze: this.waste_to_analyze,
					analysis_date: analysis_date,
					supplier_name: this.supplier_name,
					harvest_year: this.harvest_year
				}).then(response => {
					this.$store.dispatch('open_modal', {
						code: 'pending_api', params: {
							promise: new Promise((resolve, reject) => {resolve(true)}),				
							success_title: 'modal_export_rapport_durabilite_success_title',
							success_message: 'modal_export_rapport_durabilite_success_message',					
						}
					})	
				}).catch(error => {
					this.$store.dispatch('open_modal', {
						code: 'pending_api', params: {
							promise: new Promise((resolve, reject) => {reject(true)}),				
							error_title: 'modal_export_rapport_durabilite_error_title',
							error_message: 'modal_export_rapport_durabilite_error_message',					
						}
					})	
				})
			}

			console.log('exportRapport', this.durability_side_code, this.waste_to_analyze, this.analysis_date, this.supplier_name, this.harvest_year)
		}
	},
	computed:{
		hasContenu(){
			return this.$store.state.ui.sourcing.modale && this.$store.state.ui.sourcing.modale.length > 10
		}
	},
	components: {
		LoadingBtn,
		CustomInput
	}
}